import MoneyFlowChart from './_MoneyFlowChart';

export default MoneyFlowChart;
